import { membershipSettingsSchema } from '@components/SpaceSettingsPanel/membershipSettingsSchema'
import { z } from 'zod'

export const editMembershipSchema = membershipSettingsSchema

export type EditMembershipSchemaType = z.infer<typeof editMembershipSchema>
